export default __webpack_public_path__ + "static/media/DFP _D_ logo.f1779fc6.svg";